<template>
  <b-container fluid class="pb-4">
    <!-- 製品種別マスタメンテ -->
    <h1 class="fc-h1">{{ $i18n.t("codemente.title") }}</h1>
    <b-tabs content-class="mt-3">
      <!-- 検索 -->
      <b-tab :title="this.$i18n.t('codemente.tab_search')" active>
        <b-card class="w-50 mb-3">
          <form>
            <!-- 型番 -->
            <b-form-group
              id="codeSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('codemente.label_code')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="codeSearch" :placeholder="this.$i18n.t('codemente.placeholder_code')"></b-form-input>
            </b-form-group>
            <!-- レビジョン -->
            <b-form-group
              id="revisionSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('codemente.label_revision')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="revisionSearch" :placeholder="this.$i18n.t('codemente.placeholder_revision')"></b-form-input>
            </b-form-group>
            <!-- モデル名 -->
            <b-form-group
              id="petnameSearch"
              label-cols-sm="4"
              label-cols-lg="2"
              :label="this.$i18n.t('codemente.label_petname')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="petnameSearch" :placeholder="this.$i18n.t('codemente.placeholder_petname')"></b-form-input>
            </b-form-group>
            <div>
              <!-- 検索 -->
              <b-button variant="primary" @click="search" class="float-right px-5">{{ $i18n.t("codemente.button_search") }}</b-button>
            </div>
          </form>
        </b-card>
        <b-card v-if="isSearch">
          <b-row class="d-flex align-items-center">
            <!-- アクション -->
            <b-col sm="2" md="2" class="my-1">
              <b-dropdown right variant="primary" :text=actionMsg>
                <!-- 有効にする -->
                <b-dropdown-item @click="changeValidStatus('1')" >{{validMsg}}</b-dropdown-item>
                <!-- 無効にする -->
                <b-dropdown-item @click="changeValidStatus('0')" >{{invalidMsg}}</b-dropdown-item>
              </b-dropdown>
            </b-col>
            <b-col sm="2" md="2" class="my-1">
              <div>{{ $i18n.t("codemente.label_num_of_disp") }}
                <b-form-select
                  v-model="perPage"
                  id="perPageSelect"
                  size="sm"
                  :options="pageOptions"
                  style="width: auto"
                ></b-form-select>
              </div>
            </b-col>
            <b-col sm="8" md="8" class="my-1">
              <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
          </b-row>
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :per-page="perPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="items"
            :fields="fields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
            :tbody-tr-class="rowClass"
          >
            <template v-slot:head(action)="row">
              <b-form inline>
                <b-form-checkbox size="lg" :checked="isAllSelected" v-on:change="selectAll" name="check-button"></b-form-checkbox>
              </b-form>
            </template>
            <template v-slot:cell(action)="row">
              <b-form-checkbox size="lg" v-model="row.item.selectedFlg" v-on:change="selectOne(row.item.index)" name="check-button"></b-form-checkbox>
            </template>
            <template v-slot:cell(edit)="row">
              <!-- 編集 -->
              <b-button v-if="row.item.efFlg === '1'" size="sm" class="mr-2" @click="edit(row.item, row.index, $event.target)">{{ $i18n.t("codemente.button_edit") }}</b-button>
              <b-button v-if="row.item.efFlg === '0'" disabled=true size="sm" class="mr-2">{{ $i18n.t("codemente.button_edit") }}</b-button>
            </template>
          </b-table>
        </b-card>
      </b-tab>
      <!-- 新規登録 -->
      <b-tab :title="this.$i18n.t('codemente.button_register')">
        <b-card class="w-50">
          <form>
            <!-- 型番 -->
            <b-form-group
              id="code"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('codemente.label_code_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="code" maxlength="50" :placeholder="this.$i18n.t('codemente.placeholder_code')"></b-form-input>
            </b-form-group>
            <!-- レビジョン -->
            <b-form-group
              id="revision"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('codemente.label_revision_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="revision" maxlength="20" :placeholder="this.$i18n.t('codemente.placeholder_revision')"></b-form-input>
            </b-form-group>
            <!-- モデル名 -->
            <b-form-group
              id="petname"
              label-cols-sm="4"
              label-cols-lg="3"
              :label="this.$i18n.t('codemente.label_petname_mandatory')"
              label-for="input-horizontal"
            >
              <b-form-input v-model="petname" maxlength="45" :placeholder="this.$i18n.t('codemente.placeholder_petname')"></b-form-input>
            </b-form-group>
            <div>
              <!-- 新規登録 -->
              <b-button variant="primary" @click="regist" class="float-right px-5">{{ $i18n.t("codemente.button_register") }}</b-button>
            </div>
          </form>
        </b-card>
      </b-tab>
    </b-tabs>
    <!-- 製品種別を登録しました。 -->
    <confirm-modal modId="md-confirm" :msg="this.$i18n.t('codemente.info_register')" :titleMsg="this.$i18n.t('codemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="registConfirm"/>
    <!-- 製品種別を有効にしました。 -->
    <confirm-modal modId="md-confirm2" :msg="this.$i18n.t('codemente.info_valid')" :titleMsg="this.$i18n.t('codemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="validConfirm"/>
    <!-- 製品種別を無効にしました。 -->
    <confirm-modal modId="md-confirm3" :msg="this.$i18n.t('codemente.info_invalid')" :titleMsg="this.$i18n.t('codemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="invalidConfirm"/>
    <!-- 型番は必須です。 -->
    <confirm-modal modId="md-errCodeHissu" :msg="this.$i18n.t('codemente.err_code_hissu')" :titleMsg="this.$i18n.t('codemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errCodeHissuConfirm"/>
    <!-- レビジョンは必須です。 -->
    <confirm-modal modId="md-errRevHissu" :msg="this.$i18n.t('codemente.err_revision_hissu')" :titleMsg="this.$i18n.t('codemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errRevHissuConfirm"/>
    <!-- モデル名は必須です。 -->
    <confirm-modal modId="md-errPetnameHissu" :msg="this.$i18n.t('codemente.err_petname_hissu')" :titleMsg="this.$i18n.t('codemente.title')" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errPetnameHissuConfirm"/>
    <!-- その他エラー -->
    <confirm-modal modId="md-err" :msg="errMsg" :titleMsg="errSbj" :buttonMsg="this.$i18n.t('common.button_modal_confirm')" @confirm="errConfirm"/>
  </b-container>
</template>

<script>
import confirmModal from './ConfirmModal'

export default {
  components: {
    confirmModal
  },
  created () {
    var headers = {
      'Content-Type': 'application/json',
      'opId': this.$store.store.state.opId,
      'ticketId': this.$store.store.state.ticketId
    }

    var body = {}
    document.body.style.overflow = 'hidden'
    this.$store.store.state.loading = true
    this.$axios
      .post(window.END_POINT + '/common/checkLogin', body, {
        'headers': headers
      })
      .then(res => {
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        if (res.data.result !== 'OK') {
          if (res.data.result === '401') {
            // ログインしていない場合
            this.$router.push('/')
          } else {
            this.errSbj = this.$i18n.t('common.title_modal_error')
            this.errMsg = this.$i18n.t(res.data.message)
            this.$bvModal.show('md-err')
          }
        }
      })
      .catch(res => {
        // とりあえずログイン画面へ飛ばす
        this.$store.store.state.loading = false
        document.body.style.overflow = 'auto'
        console.log(res)
        this.$router.push('/')
      })

    // 更新画面から戻った場合は再検索
    var searchFlg = this.$route.query.searchFlg
    if (searchFlg !== undefined) {
      if (searchFlg[0] === 1) {
        // 配列として渡されてしまうため先頭の値のみ取得
        var tmp = this.$route.query.searchCode
        this.codeSearch = tmp[0]
        tmp = this.$route.query.searchRev
        this.revisionSearch = tmp[0]
        tmp = this.$route.query.searchPetname
        this.petnameSearch = tmp[0]
        this.search()
      }
    }
  },
  data () {
    return {
      codeSearch: null,
      revisionSearch: null,
      petnameSearch: null,
      isAllSelected: false,
      code: null,
      revision: null,
      petname: null,
      currentPage: 1,
      pageOptions: [10, 20, 50, 100],
      perPage: 10,
      totalRows: 0,
      fields: [
        { key: 'action', label: '' },
        { key: 'code', label: this.$i18n.t('codemente.label_code'), sortable: true },
        { key: 'revision', label: this.$i18n.t('codemente.label_revision'), sortable: true },
        { key: 'petname', label: this.$i18n.t('codemente.label_petname'), sortable: true },
        { key: 'uOp', label: this.$i18n.t('codemente.label_register_user'), sortable: true },
        { key: 'uDate', label: this.$i18n.t('codemente.label_register_date'), sortable: true },
        { key: 'efFlgStr', label: this.$i18n.t('codemente.label_ef_flg'), sortable: true },
        { key: 'edit', label: this.$i18n.t('codemente.label_edit') }
      ],
      items: [],
      selectedItems: [],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      noCollapse: true,
      isSearch: false,
      actionMsg: this.$i18n.t('codemente.button_action'),
      validMsg: this.$i18n.t('codemente.button_valid'),
      invalidMsg: this.$i18n.t('codemente.button_invalid'),
      errSbj: '',
      errMsg: ''
    }
  },
  methods: {
    search: function () {
      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      // 入力値を設定
      body.code = this.codeSearch
      body.codeLikeFlg = '1'
      body.rev = this.revisionSearch
      body.revLikeFlg = '1'
      body.petname = this.petnameSearch
      body.efFlg = ''

      // 型番取得
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/productinfo/select', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            var productInfoList = res.data.productInfo
            var items = []

            if (productInfoList.length === 0) {
              this.errSbj = this.$i18n.t('codemente.title')
              this.errMsg = this.$i18n.t('codemente.err_not_data')
              this.$bvModal.show('md-err')
              this.isSearch = false
              return
            }

            // 整形
            for (var i = 0; i < productInfoList.length; i++) {
              var item = {}
              item.code = productInfoList[i].code
              item.revision = productInfoList[i].rev
              item.petname = productInfoList[i].petname
              item.uOp = productInfoList[i].u_op_name
              // utc -> local 変換
              // momentオブジェクト(UTC)に変換
              var utc = this.$moment.utc(productInfoList[i].u_date, 'YYYY-MM-DD HH:mm:ss')
              if (String(utc) === 'Invalid date') {
                item.uDate = ''
              } else {
                // local時刻に変換＆フォーマット
                item.uDate = utc.local().format('YYYY-MM-DD HH:mm:ss')
              }
              item.efFlg = productInfoList[i].ef_flg
              if (item.efFlg === '1') {
                item.efFlgStr = this.$i18n.t('codemente.label_valid')
              } else {
                item.efFlgStr = this.$i18n.t('codemente.label_invalid')
                item.status = 'awesome'
              }
              item.selectedFlg = false
              item.index = i
              items.push(item)
            }
            // ページング設定
            this.totalRows = items.length
            // 一旦データクリア
            this.items.splice(0)
            // データセット
            this.items.splice(0, 0, ...items)
            // 検索結果表示
            this.isSearch = true
            // 全選択チェック
            this.isAllSelected = false
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    regist: function () {
      // 入力値チェック
      if (this.code === null || this.code === '') {
        this.$bvModal.show('md-errCodeHissu')
        return
      }
      if (this.revision === null || this.revision === '') {
        this.$bvModal.show('md-errRevHissu')
        return
      }
      if (this.petname === null || this.petname === '') {
        this.$bvModal.show('md-errPetnameHissu')
        return
      }
      if (!window.checkProhibitedLetters(this.code)) {
        this.errSbj = this.$i18n.t('codemente.title')
        this.errMsg = this.$i18n.t('codemente.err_code_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkAlphaNumSymbol(this.code)) {
        this.errSbj = this.$i18n.t('codemente.title')
        this.errMsg = this.$i18n.t('codemente.err_code_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.revision)) {
        this.errSbj = this.$i18n.t('codemente.title')
        this.errMsg = this.$i18n.t('codemente.err_revision_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkAlphaNumSymbol(this.revision)) {
        this.errSbj = this.$i18n.t('codemente.title')
        this.errMsg = this.$i18n.t('codemente.err_revision_symbol')
        this.$bvModal.show('md-err')
        return
      }
      if (!window.checkProhibitedLetters(this.petname)) {
        this.errSbj = this.$i18n.t('codemente.title')
        this.errMsg = this.$i18n.t('codemente.err_petname_symbol')
        this.$bvModal.show('md-err')
        return
      }

      var headers = {
        'Content-Type': 'application/json',
        'opId': this.$store.store.state.opId,
        'ticketId': this.$store.store.state.ticketId
      }

      var body = {}
      // 入力値を設定
      body.code = this.code
      body.rev = this.revision
      body.petname = this.petname

      // 型番登録
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/productinfo/register', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            // 登録メッセージ表示
            this.$bvModal.show('md-confirm')
          }
        })
        .catch(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    registConfirm: function () {
      this.code = ''
      this.revision = ''
      this.petname = ''
      this.$bvModal.hide('md-confirm')
    },
    changeValidStatus: function (mode) {
      // mode='1':有効、mode='0':無効
      this.selectedItems.splice(0)
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          var selectedItem = this.items[i].code + '/' + this.items[i].revision
          this.selectedItems.push(selectedItem)
        }
      }
      if (this.selectedItems.length === 0) {
        this.errSbj = this.$i18n.t('common.title_modal_error')
        this.errMsg = this.$i18n.t('codemente.err_not_selected')
        this.$bvModal.show('md-err')
        return
      }
      var body = {}
      body.mode = mode
      body.codeRev = this.selectedItems

      var headers = {
        'Content-Type': 'application/json',
        'opid': this.$store.store.state.opId,
        'ticketid': this.$store.store.state.ticketId
      }
      document.body.style.overflow = 'hidden'
      this.$store.store.state.loading = true
      this.$axios
        .post(window.END_POINT + '/master/productinfo/updateEfFlg', body, {
          'headers': headers
        })
        .then(res => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(res)
          if (res.data.result !== 'OK') {
            if (res.data.result === '401') {
              // ログインしていない場合
              this.$router.push('/')
            } else {
              this.errSbj = this.$i18n.t('common.title_modal_error')
              this.errMsg = this.$i18n.t(res.data.message)
              this.$bvModal.show('md-err')
            }
          } else {
            this.search()
            if (mode === '1') {
              // 有効
              this.$bvModal.show('md-confirm2')
            } else {
              // 無効
              this.$bvModal.show('md-confirm3')
            }
          }
        })
        .catch(err => {
          this.$store.store.state.loading = false
          document.body.style.overflow = 'auto'
          console.log(err)
          this.errSbj = this.$i18n.t('common.title_modal_error')
          this.errMsg = this.$i18n.t('common.unexpected_error')
          this.$bvModal.show('md-err')
        })
    },
    validConfirm: function () {
      this.$bvModal.hide('md-confirm2')
    },
    invalidConfirm: function () {
      this.$bvModal.hide('md-confirm3')
    },
    errCodeHissuConfirm: function () {
      this.$bvModal.hide('md-errCodeHissu')
    },
    errRevHissuConfirm: function () {
      this.$bvModal.hide('md-errRevHissu')
    },
    errPetnameHissuConfirm: function () {
      this.$bvModal.hide('md-errPetnameHissu')
    },
    edit: function (item, index, button) {
      // 検索結果保持(戻るボタン対応)
      this.$store.store.state.searchCode = this.codeSearch
      this.$store.store.state.searchRev = this.revisionSearch
      this.$store.store.state.searchPetname = this.petnameSearch

      // 編集データ
      console.log(index)
      this.$store.store.state.editId = [item.code, item.revision]
      this.$router.push({ path: 'codementeEdit' })
    },
    rowClass: function (item, type) {
      if (!item) return
      if (item.status === 'awesome') return 'table-danger'
    },
    selectAll () {
      if (this.isAllSelected) {
        this.isAllSelected = false
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].selectedFlg = false
        }
      } else {
        this.isAllSelected = true
        for (var j = 0; j < this.items.length; j++) {
          this.items[j].selectedFlg = true
        }
      }
    },
    selectOne (index) {
      this.items[index].selectedFlg = !this.items[index].selectedFlg
      var selectedCnt = 0
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].selectedFlg) {
          selectedCnt++
        }
      }
      if (selectedCnt !== this.items.length) {
        this.isAllSelected = false
      } else {
        this.isAllSelected = true
      }
    },
    errConfirm: function () {
      this.$bvModal.hide('md-err')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Codemente.vue